const Header = () => {
  return (
    <section className="heading">
      <h1>PAINT</h1>
    </section>
  );
};

export default Header;
